// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ButtonLoading_wrapper__z8fF9","btn_loading":"ButtonLoading_btn_loading__14-Yb","spinning":"ButtonLoading_spinning__1OB-3"};